import { createFileRoute, redirect } from '@tanstack/react-router';
import { meQueryOptions } from '../api/me.ts';
import { isUnauthenticated } from '../api/query-client.ts';
import { AppShell } from '../shell/app-shell.tsx';
import { ShellLoadError, ShellLoading } from '../shell/shell-states.tsx';

// Every page behind sign-in (plan §9). /me is loaded once here; children read `context.me`.
export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context }) => {
    try {
      return { me: await context.queryClient.ensureQueryData(meQueryOptions) };
    } catch (err) {
      if (isUnauthenticated(err)) throw redirect({ to: '/login', replace: true });
      throw err;
    }
  },
  pendingComponent: ShellLoading,
  errorComponent: ShellLoadError,
  component: AppShell,
});
